export default "__VITE_ASSET__Bbnzehun__ 100w";